// for production
export const ApiUrl = "https://cms.lasalleindia.org/api";

// for development
// export const ApiUrl = "http://127.0.0.1:8000/api";

// for production
export const ReligioUrl = "https://app.lasalleindia.org/api";